import { useIsEditorLocked } from "./useIsEditorLocked";

/**
 * Whether the controls of a form section are disabled: by a missing ability or by the editor's
 * lock. Only the ability explains itself with the permissions message of the section.
 */
export const useSectionDisabled = (isDisabledByAbility: boolean): boolean => {
  const isLocked = useIsEditorLocked();

  return isDisabledByAbility || isLocked;
};
